import React from "react"
import { Column, Container, Row } from "../../../components/Grid"
import Hero from "../../../components/Hero"
import Layout from "../../../components/Layout"
import Resource from "../../../components/Resource"
import Section from "../../../components/Section"
import SEO from "../../../components/Seo"

const StudentsPage = () => (
  <Layout>
    <SEO title="Estudiantes" />
    {/***************  HERO ***************/}
    <Section className="hero">
      <Hero
        title="Estudiantes"
        infographic="img-hero-infographic-students.png"
        body="¡Toma el control de tus decisiones! Fortalece tu capacidad para enfrentar la presión social y cuídate del uso indebido de sustancias para que tu futuro sea más saludable e inteligente."
        image="img-hero-students.jpg"
      />
    </Section>

    <Section className="resource-container midgray-background">
      <Column span={12}>
        <Container>
          <div>
            <h2>Animación interactiva </h2>
            <p>
              Una aventura animada que fortalece la capacidad de tomar
              decisiones saludables mediante actividades dinámicas.
            </p>
          </div>
        </Container>
        <Resource
          labelWithNewFlag="Animación interactiva"
          image="CVS-ATS-Title-Card-Spanish.jpg"
          title="Piénsalo bien: una experiencia para elegir tu propio camino"
          grade="De 9.° a 12.° grado"
          description={
            <p>
              En esta experiencia, los estudiantes enfrentarán las dificultades
              que surgen cuando no administran bien su tiempo. A lo largo de un
              agitado día escolar, deberán poner en práctica su capacidad para
              tomar decisiones saludables mientras lidian con la presión del
              grupo y las tentadoras soluciones rápidas, ¡todo esto mientras se
              acerca un examen importante!
            </p>
          }
          actions={[
            {
              label: "Comenzar",
              path: "/es/educators/interactive",
              type: "module",
              moduleName: "Choose Your Own Adventure (Spanish)",
              locked: false,
              target: "_self",
            },
          ]}
          horizontal
        />
      </Column>
    </Section>

    {/* Ready-To-Use Activities */}
    <Section className="midgray-background">
      <Container>
        <div className="resource__label">Actividades listas para usar</div>
        <Row className="white-background educators__CYA-row pt-1 pb-1 educators__equal-height">
          <Column span={4}>
            <Resource
              image="CVS-Pharma-RTU-Thumbnail-ImpactsofSocialMedia.jpg"
              title="La influencia de las redes sociales"
              grade="De 9.° a 12.° grado"
              resourceContentClass="educators__CYA-resource-content"
              resourceContainerClass="educators__CYA-resource-with-shadow"
              description={
                <p>
                  Mediante esta actividad de bienestar, los estudiantes
                  aprenderán a desarrollar una relación consciente y
                  constructiva con las redes sociales.
                </p>
              }
              actions={[
                {
                  label: "Abrir la actividad lista para implementar ",
                  url:
                    "https://app.discoveryeducation.com/learn/player/f87b52a6-6c53-4b4e-b39d-d68b7645e7e4",
                  type: "external",
                  locked: false,
                },
              ]}
            />
          </Column>
          <Column span={4}>
            <Resource
              image="CVS-Pharma-RTU-Thumbnail-NavigatingSocialInfluence.jpg"
              title="La influencia social"
              grade="De 9.° a 12.° grado"
              resourceContentClass="educators__CYA-resource-content"
              resourceContainerClass="educators__CYA-resource-with-shadow"
              description={
                <p>
                  La actividad de bienestar enseña a los estudiantes estrategias
                  para manejar la presión del grupo mediante la práctica de
                  interacciones positivas.
                </p>
              }
              actions={[
                {
                  label: "Abrir la actividad lista para implementar ",
                  url:
                    "https://app.discoveryeducation.com/learn/player/a107b361-6d3a-4694-8edb-290d783bdac1",
                  type: "external",
                  locked: false,
                },
              ]}
            />
          </Column>
          <Column span={4}>
            <Resource
              image="CVS-Pharma-RTU-Thumbnail-MentalBreathingSpace.jpg"
              title="Manejo del estrés"
              grade="De 9.° a 12.° grado"
              resourceContentClass="educators__CYA-resource-content"
              resourceContainerClass="educators__CYA-resource-with-shadow"
              description={
                <p>
                  Los estudiantes aprenderán técnicas para el manejo del estrés
                  en esta actividad de bienestar.
                </p>
              }
              actions={[
                {
                  label: "Abrir la actividad lista para implementar ",
                  url:
                    "https://app.discoveryeducation.com/learn/player/5ebaf9bb-2ecf-4ddd-ac5e-7fbadec9717a",
                  type: "external",
                  locked: false,
                },
              ]}
            />
          </Column>
        </Row>
      </Container>
    </Section>

    {/***************  RESOURCE HORIZONTAL ***************/}
    <Section className="resource-container midgray-background pt-0">
      <Column span={12}>
        <Container>
          <div>
            <h2>Exploración digital</h2>
            <p>
              Descubre un módulo interactivo diseñado para fomentar la toma de
              decisiones responsables con respecto al uso indebido de sustancias
              frente a la presión de grupo.
            </p>
          </div>
        </Container>
        <Resource
          label="Exploración digital"
          image="thumbnail-digital-exploration@2x.jpg"
          title="El uso indebido de medicamentos con receta, el cerebro y el cuerpo del adolescente"
          grade="De 9.° a 12.° grado"
          description={
            <p>
              Los estudiantes explorarán en este módulo interactivo los efectos
              que tiene en el cerebro y el cuerpo adolescente el uso no indicado
              de medicamentos recetados. A partir de esta información,
              desarrollarán criterios para tomar decisiones responsables cuando
              enfrenten presiones de sus compañeros para usar medicamentos de
              forma indebida.
            </p>
          }
          actions={[
            {
              label: "Comenzar",
              path: "/prescription-medication-misuse",
              type: "module",
              moduleName: "Prescription Medication Misuse",
              locked: false,
            },
          ]}
          horizontal
        />
      </Column>
    </Section>
  </Layout>
)
export default StudentsPage
